module.exports = __webpack_public_path__ + "img/banner.98e22cad.jpg";